import { render, staticRenderFns } from "./DeletionValidationModal.vue?vue&type=template&id=82e4e07e&"
import script from "./DeletionValidationModal.vue?vue&type=script&lang=js&"
export * from "./DeletionValidationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports